import {Component, Input} from '@angular/core';
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";

@Component({
    selector: 'db-generation-failed',
    templateUrl: './generation-failed.component.html',
    styleUrls: ['./generation-failed.component.scss'],
    standalone: false
})
export class GenerationFailedComponent {

  @Input() canRetry = true;

  constructor(
    private _activeModal: DbActiveModal,

  ) { }

  public retry(): void {
    this._activeModal.close();
  }

  public openChat() {
    this._activeModal.dismiss('chat');
  }
}
